export default "<h1>404 - Seite nicht gefunden!</h1>\n<a routerLink=\"/\" routerLinkActive=\"active\">Zum Start</a>\n"